import React from "react"
import { createStackNavigator } from "@react-navigation/stack"
import {
  MemberScreen,
  PromotionDetailScreen,
  PromotionScreen,
  PointHistoryScreen,
  RedeemScreen,
  VoucherScreen,
  VoucherDetailScreen,
  EditProfileScreen,
} from "screens"
import { translate } from "i18n"
import MaterialIcons from "@expo/vector-icons/MaterialIcons"

import { Header } from "components"
import { VoucherHomeScreen } from "screens/Application/VoucherHome"
import { ForYouScreen } from "screens/Application/ForYou"
import { ForYouDetailScreen } from "screens/Application/ForYouDetails"
import { StampsScreen } from "screens/Application/Stamps"
import { StampsDetailScreen } from "screens/Application/StampsDetails"

export type VoucherParamList = {
  voucherHome: undefined
  voucher: undefined
  member: undefined
  redeem: undefined
  pointHistory: undefined
  promotion: undefined
  promotionDetail: undefined
  foryou: undefined
  forYouDetails: undefined
  voucherDetail: undefined
  stamps: undefined
  stampsDetails: undefined
  editProfile: undefined
}
const Stack = createStackNavigator<VoucherParamList>()

export const VoucherCombineStack = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        headerBackImage: () => <MaterialIcons name="chevron-left" color="white" size={42} />,
        header: (props) => {
          return <Header {...props} />
        },
        headerBackTitleVisible: false,
        headerTitleAlign: "left",
        headerStyle: {
          backgroundColor: "transparent",
          borderBottomWidth: 0,
        },
        headerTintColor: "white",
        cardStyle: { flex: 1 },
      }}
    >
      <Stack.Screen
        name="voucherHome"
        component={VoucherHomeScreen}
        options={{
          headerTitle: translate("redeemScreen.title"),
        }}
      />
      <Stack.Screen
        name="voucher"
        component={VoucherScreen}
        options={{
          headerTitle: translate("redeemScreen.title"),
        }}
      />
      <Stack.Screen
        name="voucherDetail"
        component={VoucherDetailScreen}
        options={{
          headerTitle: translate("redeemScreen.title"),
        }}
      />
      <Stack.Screen
        name="redeem"
        component={RedeemScreen}
        options={{
          headerTitle: translate("redeemScreen.title"),
        }}
      />
      <Stack.Screen
        name="pointHistory"
        component={PointHistoryScreen}
        options={{
          headerTitle: translate("pointHistoryScreen.title"),
        }}
      />
      <Stack.Screen name="promotion" component={PromotionScreen} />
      <Stack.Screen
        name="promotionDetail"
        component={PromotionDetailScreen}
        options={{
          headerShown: false,
        }}
      />

      <Stack.Screen name="foryou" component={ForYouScreen} />
      <Stack.Screen name="forYouDetails" component={ForYouDetailScreen} />
      <Stack.Screen
        name="stamps"
        component={StampsScreen}
        options={{
          headerTitle: translate("redeemScreen.title"),
        }}
      />
      <Stack.Screen
        name="stampsDetails"
        component={StampsDetailScreen}
        options={{
          headerTitle: translate("redeemScreen.title"),
        }}
      />
      <Stack.Screen
        name="editProfile"
        component={EditProfileScreen}
        options={{
          headerTitle: translate("editProfileScreen.title"),
        }}
      />
    </Stack.Navigator>
  )
}
